"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Indicator = _interopRequireDefault(require("./Indicator"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var _default = function _default(_ref) {
  var level = _ref.level,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_Indicator.default, _extends({}, className ? {
    className: className
  } : {}, {
    bgColor: "#D30079",
    color: "#FFFFFF",
    title: "Niveau",
    text: level
  }));
};
exports.default = _default;